import { Button, Checkbox } from '@racefront/shadcn-ui'
import { Loader2 } from 'lucide-react'
import { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { SignUpData } from '../../../types/user'

interface RegistrationTokenAcceptanceProps {
  onAccept: (data: SignUpData) => void
  isLoading: boolean
}

const TERMS_URL = 'https://raceid.com/en/public/terms'

export function RegistrationTokenAcceptance({ onAccept, isLoading }: RegistrationTokenAcceptanceProps) {
  const [termsAccepted, setTermsAccepted] = useState(false)

  const handleAccept = () => {
    if (termsAccepted) {
      // Pass minimal data since registrationToken is the main requirement
      onAccept({} as SignUpData)
    }
  }

  return (
    <div className="flex w-full flex-col items-center space-y-6">
      <div className="w-full max-w-md rounded-lg border p-6">
        <h4 className="mb-4 text-lg font-semibold">
          <FormattedMessage id="signup.registration_token.title" defaultMessage="Complete Your Registration" />
        </h4>

        <div className="mb-6 flex items-start space-x-3">
          <Checkbox
            id="terms"
            checked={termsAccepted}
            onCheckedChange={(checked) => setTermsAccepted(checked === true)}
            className="mt-1"
          />
          <label htmlFor="terms" className="cursor-pointer text-sm leading-relaxed">
            <FormattedMessage
              id="signup.registration_token.terms"
              defaultMessage="You should agree to the {termsLink} in order to create your account."
              values={{
                termsLink: (
                  <a
                    href={TERMS_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary font-medium underline"
                    title="Terms and Conditions"
                  >
                    <FormattedMessage id="signup.terms_link" defaultMessage="terms & conditions" />
                  </a>
                ),
              }}
            />
          </label>
        </div>

        <Button onClick={handleAccept} disabled={!termsAccepted || isLoading} className="w-full" size="lg">
          {isLoading ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              <FormattedMessage id="signup.registration_token.processing" defaultMessage="Processing..." />
            </>
          ) : (
            <FormattedMessage id="signup.registration_token.accept_cta" defaultMessage="Accept and Verify" />
          )}
        </Button>
      </div>
    </div>
  )
}
